export default {
	XS: 320,
	S: 480,
	M: 768,
	L: 992,
	XL: 1200,
};



// WEBPACK FOOTER //
// ./src/styles/breakpoints.js